// extracted by mini-css-extract-plugin
export default {"signup":"Signup_signup__wcR0b","error":"Signup_error__gS6Cj","button":"Signup_button__nO93v"};